import React from 'react';
import {observer} from "mobx-react";
import {useScreenMediaQueriesChecks} from "../../../hooks/use-screen-media-queries-checks.hook";
import {
    SearchMaskWebappLageScreenComponent
} from "../../../components/search-mask/webapp/large-screen/search-mask.webapp.lage-screen.component";
import {AgencyPage} from "../agency.page";
import {
    SearchMaskWebappSmallScreenComponent
} from "../../../components/search-mask/webapp/small-screen/search-mask.webapp.small-screen.component";
import styled from "styled-components";

const PageContentBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
`

export const AgencyHomeWebappPage: React.FC = observer(() => {
    const mediaQuery = useScreenMediaQueriesChecks();

    const renderSearchMask = () => {
        if(mediaQuery.smallScreen) {
            return (<SearchMaskWebappSmallScreenComponent/>);
        } else {
            return (<SearchMaskWebappLageScreenComponent/>);
        }
    }


    return (
        <AgencyPage>
            <PageContentBox>
                {renderSearchMask()}
            </PageContentBox>
        </AgencyPage>
    )

})